import React from "react";
import { RatingInfoContent } from "./RatingInfoContent";

export const KnowledgeRatingInfo = () => <RatingInfoContent dimension="knowledge" />;

export default KnowledgeRatingInfo;
